/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface FiscalCode { 
    code?: string;
    type?: FiscalCode.TypeEnum;
}
export namespace FiscalCode {
    export type TypeEnum = 'Auto' | 'Manual' | 'None';
    export const TypeEnum = {
        Auto: 'Auto' as TypeEnum,
        Manual: 'Manual' as TypeEnum,
        None: 'None' as TypeEnum
    };
}
